import Button from '@admin/components/button'
import Icon from '@admin/components/icon'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

class InApp extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    notifications: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.bool,
    onChange: PropTypes.func,
    onReady: PropTypes.func
  }

  state = {
    value: true
  }

  _handleDemo = this._handleDemo.bind(this)
  _handleToggle = this._handleToggle.bind(this)

  render() {
    const { value } = this.state
    return (
      <div className="maha-preferences">
        <div className="maha-preference" onClick={ this._handleToggle }>
          <div className="maha-preference-icon">
            <Icon icon={ value ? 'check-square' : 'square-o' } />
          </div>
          <div className="maha-preference-label">
            <T text="t(Display in-app notifications)" /> (<Button { ...this._getDemo() }/>)
          </div>
        </div>
      </div>
    )
  }

  componentDidMount(){
    const { defaultValue } = this.props
    const value = defaultValue === true
    this.setState({ value })
    this.props.onReady()
  }

  componentDidUpdate(prevProps, prevState) {
    const { value } = this.state
    if(value !== prevState.value) {
      this.props.onChange(value)
    }
  }

  _getDemo() {
    return {
      label: 'demo',
      className: 'link',
      handler: this._handleDemo
    }
  }

  _handleDemo(e) {
    const { team } = this.context.admin
    e.stopPropagation()
    this.context.notifications.pushInApp({
      team,
      title: 'In-App Notification',
      body: 'This is an in-app notification',
      sound: null
    })
  }

  _handleToggle() {
    const { value } = this.state
    this.setState({
      value: !value
    })
  }

}

export default InApp
